import PropTypes from "prop-types";

export const CHRType = PropTypes.shape({
  version: PropTypes.string,
  item: PropTypes.arrayOf(
    PropTypes.shape({
      conditions_list: PropTypes.arrayOf(
        PropTypes.shape({
          db_key_list: PropTypes.arrayOf(PropTypes.shape({})),
          ghr_link: PropTypes.string,
          html_text: PropTypes.string,
          name: PropTypes.string,
        })
      ),
      date_published_by_ghr: PropTypes.string,
      html_text: PropTypes.string,
    })
  ),
});
